<!-- 嵌入式-软件版本管理 -->
<template>
  <el-card style="position: relative; z-index: 0; width: 100%">
    <el-tabs v-model="activeTab" type="border-card">
      <el-tab-pane label="产品版本" name="tabProduct">
        <div class="top">
          <div class="left">
            <el-button
              type="primary"
              @click="onCreateItem"
              v-permission="'dci_version_manage-*'"
            >
              <i class="fas fa-fw fa-plus"></i> 新增文件系统版本
            </el-button>
          </div>
          <div class="right">
            <select2
              labelName="NameNumber"
              v-model="form.DciProductModelID"
              url="dci/model/product/list?order=name"
              clearable
              placeholder="选择产品型号"
              no-data-text="没有产品型号"
              :urlParams="{
                where: {},
              }"
              q="NameNumber:like"
              :qinwhere="true"
              :queryOne="false"
            ></select2
            >&nbsp;
            <el-input
              v-model.trim="form['PvName:like']"
              placeholder="请输入文件系统版本"
              @keydown.enter.native="onSubmitQuery"
              style="width: 200px"
            ></el-input
            >&nbsp;
            <el-button type="primary" @click="onSubmitQuery">
              <i class="fas fa-search"></i>
            </el-button>
          </div>
        </div>
        <el-table :data="itemList" v-loading="loading" size="medium">
          <el-table-column
            type="index"
            :index="pager.size * (pager.page - 1) + 1"
            :width="
              Math.max(48, (pager.size * pager.page).toString().length * 12)
            "
          />
          <el-table-column label="关联产品型号" width="250">
            <template slot-scope="scope">
              <div v-if="scope.row.DciProductModels">
                <div v-for="mod in scope.row.DciProductModels" :key="mod.ID">
                  <div>{{ mod.NameNumber }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="DciProductModel.Number" label="产品型号" /> -->
          <el-table-column prop="PvName" label="文件系统版本" width="250" />
          <el-table-column
            prop="IsDefault"
            label="是否默认"
            width="80"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.IsDefault" type="warning"> 是 </el-tag>
              <el-tag v-else type="success"> 否 </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="IsPublic"
            label="是否公开发布"
            width="110"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.IsPublic" type="warning"> 是 </el-tag>
              <el-tag v-else type="success"> 否 </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="发布日期" width="100" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.PublishAt">
                {{ $sys.dateFormat(scope.row.PublishAt, "Y-m-d") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="Desc" label="说明" />
          <el-table-column width="150" label="操作">
            <template slot-scope="{ row }">
              <el-button
                type="primary"
                @click.stop="onEditItem(row)"
                title="编辑"
                v-permission="'dci_version_manage-*'"
              >
                <i class="fas fa-pencil-alt"></i>
              </el-button>
              <el-button
                type="primary"
                @click.stop="onConfigItem(row)"
                title="相关程序版本"
              >
                <i class="fas fa-cogs"></i>
              </el-button>
              <el-button
                type="danger"
                @click.stop="onDeleteItem(row)"
                title="删除"
                v-permission="'dci_version_manage-*'"
              >
                <i class="fas fa-trash-alt"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="clearfix mar-top-10">
          <el-pagination
            class="pull-right"
            @current-change="onChangePage"
            layout="total, prev, pager, next"
            :total="pager.total"
            :current-page="pager.page"
            :page-size="pager.size"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="程序管理" name="tabSoftware">
        <div class="top">
          <div class="left">
            <el-button
              type="primary"
              @click="onCreateClassItem"
              v-permission="'dci_version_manage-*'"
            >
              <i class="fas fa-fw fa-plus"></i> 新增程序分类
            </el-button>
          </div>
          <div class="right">
            <el-input
              v-model="classForm['ClassName:like']"
              placeholder="请输入程序分类名称"
              @keydown.enter.native="onSubmitClassQuery"
              style="width: 200px"
            ></el-input
            >&nbsp;
            <el-button type="primary" @click="onSubmitClassQuery">
              <i class="fas fa-search"></i>
            </el-button>
          </div>
        </div>
        <el-table :data="classItemList" v-loading="classLoading" size="medium">
          <el-table-column
            type="index"
            :index="classPager.size * (classPager.page - 1) + 1"
            :width="
              Math.max(
                48,
                (classPager.size * classPager.page).toString().length * 12
              )
            "
          />
          <el-table-column prop="ClassName" label="程序分类名称" width="300" />
          <el-table-column prop="Desc" label="说明" width="300" />
          <el-table-column prop="SoftwareNames" label="相关应用">
            <template slot-scope="{ row }">
              <el-tag
                v-for="(p, index) in row.SoftwareNames"
                :key="index"
                class="mr-5 mb-5"
                >{{ p }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column width="150" label="操作">
            <template slot-scope="{ row }">
              <el-button
                type="primary"
                @click.stop="onEditClassItemClick(row)"
                title="编辑"
                v-permission="'dci_version_manage-*'"
              >
                <i class="fas fa-pencil-alt"></i>
              </el-button>
              <el-button
                type="primary"
                @click.stop="onConfigClassItem(row)"
                title="相关应用程序"
              >
                <i class="fas fa-cogs"></i>
              </el-button>
              <el-button
                type="danger"
                @click.stop="onDeleteClassItem(row)"
                title="删除"
                v-permission="'dci_version_manage-*'"
              >
                <i class="fas fa-trash-alt"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="clearfix mar-top-10">
          <el-pagination
            class="pull-right"
            @current-change="onChangeClassPage"
            layout="total, prev, pager, next"
            :total="classPager.total"
            :current-page="classPager.page"
            :page-size="classPager.size"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 文件版本相关弹框 -->
    <product-item-form
      v-model="item"
      :visible.sync="itemVisible"
      @form:saved="getItemList"
    />
    <config-form
      v-model="item"
      :visible.sync="configVisible"
      @form:saved="getItemList"
    />

    <!-- 程序管理相关弹框 -->
    <el-dialog
      :title="(this.classItem.ID ? '编辑' : '新增') + '程序分类'"
      :visible.sync="classItemVisible"
      :close-on-click-modal="false"
      @close="onCloseClassItem"
      width="30%"
      append-to-body
    >
      <el-form
        ref="classItemForm"
        label-width="150px"
        :model="classItem"
        :rules="classRules"
      >
        <el-form-item label="程序分类名称" prop="ClassName">
          <el-input
            v-model.trim="classItem.ClassName"
            placeholder="请输入程序分类名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="说明" prop="Desc">
          <el-input
            v-model.trim="classItem.Desc"
            :autosize="{ minRows: 3 }"
            type="textarea"
            placeholder="请输入说明"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseClassItem">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button
          type="primary"
          @click="onConfirmClassItem"
          :disabled="submitting"
        >
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>

    <config-software-form
      v-model="classItem"
      :visible.sync="configClassVisible"
      @form:saved="getClassItemList"
    />
  </el-card>
</template>

<script>
//文件版本相关弹框
import ProductItemForm from "./productItemForm.vue"; //新增/编辑文件系统版本
import ConfigForm from "./configForm.vue"; //配置相关程序版本

// 程序管理相关弹框
import ConfigSoftwareForm from "./configSoftwareForm.vue"; //配置相关应用程序

export default {
  components: {
    ProductItemForm,
    ConfigForm,
    ConfigSoftwareForm,
  },
  data() {
    return {
      activeTab: "tabProduct",
      //=================产品版本（以下）=====================================
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      form: {
        DciProductModelID: "",
        "PvName:like": "",
      },
      item: this.getEmptyItem(),
      itemVisible: false,
      configVisible: false,

      //=================程序管理（以下）=====================================
      classItemList: [],
      classLoading: false,
      classPager: {
        total: 0,
        page: 1,
        size: 15,
      },
      classForm: {
        "ClassName:like": "",
      },
      classItem: {
        ID: "",
        ClassName: "", //程序分类名称
        Desc: "", //描述
      },
      classRules: {
        ClassName: [
          {
            required: true,
            message: "程序分类名称不能为空",
            trigger: "blur",
          },
        ],
      },
      classItemVisible: false,
      configClassVisible: false,
      submitting: false,
    };
  },
  created() {
    this.activeTab = "tabProduct";
    this.getItemList();
    this.getClassItemList();
  },
  methods: {
    //=================产品版本（以下）=====================================

    //获取文件系统版本列表
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/pv/productversion", {
          params: {
            where: {
              "PvName:like": this.form["PvName:like"],
            },
            dciProductModelID:this.form.DciProductModelID,
            ...this.pager,
            with: ["DciProductModels", "DciPvSoftwareVersions"], //相关程序版本
            order: ["-publish_at","-pv_name"], //发布日期倒序
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //新增文件系统版本
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    //编辑文件系统版本
    onEditItem(row) {
      this.item = row;
      this.itemVisible = true;
    },
    //配置相关程序版本
    onConfigItem(row) {
      this.item = row;
      this.configVisible = true;
    },
    //删除文件系统版本
    onDeleteItem(row) {
      this.$confirm("确定要删除此文件系统版本吗？", "提示")
        .then(() => this.$axios.delete(`dci/pv/productversion/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getEmptyItem() {
      return {
        PvName: "", //文件系统版本
        DciProductModelID: "", //产品型号id
        Desc: "", //描述
        IsDefault: false, //是否产品默认版本
        IsPublic: false, //是否公开发布
        PublishAt: new Date(), //发布日期
      };
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },

    //=================程序管控（以下）=====================================

    //获取程序分类列表
    getClassItemList() {
      this.classLoading = true;
      this.$axios
        .get("dci/pv/softwareClassify", {
          params: {
            where: this.classForm,
            ...this.classPager,
            with: ["DciPvSoftwares.DciPvSoftwareVersions"], //相关应用程序
            order: ["class_name"], //程序分类名称
          },
        })
        .then((response) => {
          this.classItemList = response.data.data;
          this.classPager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.classLoading = false;
        });
    },
    //新增程序分类
    onCreateClassItem() {
      this.classItem = this.getEmptyClassItem();
      this.classItemVisible = true;
    },
    onCloseClassItem() {
      this.classItemVisible = false;
      this.$refs.classItemForm.resetFields();
    },
    //点击编辑程序分类
    onEditClassItemClick(row) {
      this.classItem.ID = row.ID;
      this.classItem.ClassName = row.ClassName;
      this.classItem.Desc = row.Desc;
      this.classItemVisible = true;
    },
    //确认新增/保存程序分类
    onConfirmClassItem() {
      this.$refs.classItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.classItem);
        const itemData = { ...this.classItem };
        // 保存的操作
        this.$axios
          .request({
            url: this.classItem.ID
              ? `dci/pv/softwareClassify/${itemData.ID}`
              : "dci/pv/softwareClassify",
            method: itemData.ID ? "put" : "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
            this.submitting = false;
            this.classItemVisible = false;
            this.getClassItemList();
            this.$message.success("提交成功");
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
          });
      });
    },
    //配置相关应用程序
    onConfigClassItem(row) {
      this.classItem = row;
      this.configClassVisible = true;
    },
    //删除程序分类
    onDeleteClassItem(row) {
      this.$confirm("确定要删除此程序分类吗？", "提示")
        .then(() => this.$axios.delete(`dci/pv/softwareClassify/${row.ID}`))
        .then(() => {
          this.getClassItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getEmptyClassItem() {
      return {};
    },
    onSubmitClassQuery() {
      this.classPager.page = 1;
      this.getClassItemList();
    },
    onChangeClassPage(page) {
      this.classPager.page = page;
      this.getClassItemList();
    },
  },
};
</script>
<style lang="scss" scoped>
.top {
  text-align: right;
  background-color: #f5f7fa;
  height: 30px;
  padding: 15px 20px 10px 20px;
  margin: -20px -20px 10px -20px;
}
.left {
  float: left;
  text-align: left;
  width: 100px;
  background-color: #f5f7fa;
}
.right {
  float: right;
  text-align: right;
  width: 80%;
}
</style>
